import axios from 'axios'
import router from '@/router/index'
import { Message } from 'element-ui'
console.log(Message)
// const pageCode = localStorage.getItem('pageCode')
// const pati = localStorage.getItem('pati')
console.log(localStorage.getItem('pati'))
const protocol = window.location.protocol // 协议
const host = window.location.host // 主机
const reg = /^localhost+/
console.log(process.env.VUE_APP_BASE_API)
if (reg.test(host)) {
  // 若本地项目调试使用
  axios.defaults.baseURL = process.env.VUE_APP_BASE_API
} else {
  // 动态请求地址             协议               主机
  axios.defaults.baseURL = protocol + '//' + host
}

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  withCredentials: true,
  timeout: 30000 // request timeout
})
// const requestUrl = [
//   'api/orders/btsend',
//   '/api/goods/sync',
//   '/api/waybill/search',
//   '/api/waybill/open',
//   '/api/waybill/branch',
//   '/api/waybill/outer',
//   '/api/waybill/used',
//   '/api/refund/detail',
//   '/api/refund/refund',
//   '/api/refund/dress',
//   'api/shop/info',
//   '/api/delivery/wpget',
//   '/api/delivery/cancel',
//   '/api/orders/send',
//   '/api/delivery/fwpget',
//   '/api/delivery/freeCancel',
//   '/api/waybill/wpcancel'
// ]
// service.interceptors.request.use(request => {
//   /**
//    * undefined null '' === false
//    * @type {{authorization: string}}
//    */
//   console.log(request.url)
//   if (requestUrl.indexOf(request.url) !== -1) {
//     request.headers.common = {
//       'X-PDD-PageCode': pageCode,
//       'X-PDD-Pati': pati
//     }
//   }

//   return request
// })

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // const res = response.data
    console.log(response)
    // if the custom code is not 20000, it is judged as an error.
    if (response.status === 200) {
      if (response.data.code) {
        if (response.data.code === 2) {
          // 未登录失效
          // if (document.getElementsByClassName('el-message').length === 0) {
          //   Message({
          //     showClose: true,
          //     message: response.data.msg || '加载失败，请稍后再试',
          //     type: 'warning'
          //   })
          // }
          // localStorage.removeItem('token')
          router.push('/login')
          // router.push('/login')

          return Promise.reject(response).catch(e => {})
        }
      }
      return Promise.resolve(response).catch(e => {})
    } else {
      return Promise.reject(response).catch(e => {
        console.log(e)
      })
    }
  },
  error => {
    // console.log('err' + error) // for debug
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          // localStorage.removeItem('token')
          router.push('/login')
          // router.push('/login')
          break

        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          // 清除token
          break

        // 404请求不存在
        case 404:
          break
        // 其他错误，直接抛出错误提示
        default:
      }
      return Promise.reject(error.response)
      // Message({
      //     message: error.message,
      //     type: 'error',
      //     duration: 5 * 1000
      // })
      // return Promise.reject(error.response)
    }
  }
)

export default service
